<template>
    <div class="how-to-play__games">
        <h1 class="how-to-play__games-title">{{ getTranslatedText('Lucky numbers - Symbol - meaning') }}</h1>
        <div class="how-to-play__games-list">
            <div class="how-to-play__games-item" v-for="(v, i) in listNumber" :key="i">
                <div class="how-to-play__games-item-box-image">
                    <img class="how-to-play__games-item-image" :src="addTimestampToURL(v.icon.active)" :alt="v.number" />
                    <span class="how-to-play__games-item-number">{{ v.number }}</span>
                </div>
                <span class="how-to-play__games-item-title">{{ v.title }}</span>
                <span class="how-to-play__games-item-description">{{ v.description }}</span>
            </div>
        </div>
    </div>
</template>
<script>
import languageMixins from '@/mixins/language/language-mixins'
import VersionCache from '@/mixins/version-cache/version-cache-mixins'

export default {
    mixins: [languageMixins, VersionCache],
    props: {
        listNumber: {
            type: Array,
            default: () => [],
        },
    },
}
</script>

<style lang="scss">
@import '~ThemePath/scss/home/index.scss';
</style>
